import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import ColumnUtils from '@/utils/ColumnUtils'
import { getFilterCacheList, getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { ImportConstants } from '@/class/cargo/model/utils/ImportConstants'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Company } from '@/class/model/mdm/Company'
import { ClosingAccount } from '@/class/model/act/ClosingAccount'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { batchAddJob, batchRemoveJob, checkPoNoIsExist } from '@/api/booking/job'
import { batchCloneLcLJob } from '@/api/AirImport/aiBooking'
import { checkJobForShared } from '@/api/seaExport/seaExportJob'
import { cleanCircleObject, deepCopy, multiply, mergeArray } from '@/utils/commonUtil'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { cache } from '@/utils/cacheManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { AirPort } from '@/class/model/mdm/AirPort'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { sortByMultiField } from '@/utils'
import $store from '@/store'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { HAWB } from '@/class/cargo/model/parameters/CargoDocConsts'

export default {
  methods: {
    onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      /* ****************************** 初始化 begin ****************************** */
      this.salesOfficeCheck = Number(this.context.config.get('SalesOfficeCheck')) === 1
      this.isAddUserDefinedRoles = Number(this.context.config.get('IsAddUserDefinedRoles')) === 1
      this.openProjectConfig = Number(this.context.config.get('openProjectConfig')) === 1
      this.needConfirmProjectNo = Number(this.context.config.get('needConfirmProjectNo')) === 1
      this.isWithinCloseAccountDate = false
      this.txtSalesOffice = ''
      /* ****************************** end ****************************** */
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      this.job = row
      if (row.jobNo) {
        ClosingAccount.isContainClosedCharge(this.context.office.officeId, row.jobNo).then(res => {
          this.isWithinCloseAccountDate = Boolean(res.data)
        })
      }
      const mbl = row.mbl.replace('-', '')
      this.mblCode = mbl.substr(0, 3)
      this.mblNum = mbl.substr(3)
      this.onMblCodeNumBlur()
      row.tradeTerm = row.tradeTerm || '110'
      this.refreshTotals()
      if (row.salesOffice) {
        this.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', row.salesOffice, 'chineseName')
      }
      this.checkValueMatch()
      JobUtils.setSailingDay(this.job)
      OverseaCustomerUtils.loadOverseaAgentChanged(this)
      if (!this.isEdit && this.job.poNo && this.needConfirmProjectNo && !this.openProjectConfig) {
        checkPoNoIsExist(this.job.poNo, this.job.uuid).then(res => { this.poNoRed = (res.data > 0) })
      }
      JobUtils.getReceiptCharges(this.job)
      this.initRegion()
      if (!this.job.uuid) {
        JobUtils.matchUserPortConfig(this, this.job)
        JobUtils.matchRegionWarehouseMappingConfig(this.job, null, false, null, null, true)
      } else {
        JobUtils.matchUserPortConfig(this, this.job, false, null, { keepOriginValue: true })
      }
      this.view.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.operateType, this.job.fba)
      this.setSecondaryCustomJobTypeFunc()
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setUserDefinedRoleDataUI()
      }
    },
    async initRegion() {
      if (this.job.loadingPortCode) {
        const port = await AirPort.getAirportByCode(this.job.loadingPortCode)
        if (port && port.region) {
          const regions = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
          const region = regions.find(p => p.code === port.region)
          this.job.regionName = region ? (this.isZh() ? region.name : region.nameEnglish) : ''
        }
      } else {
        this.job.regionName = ''
      }
    },
    // 统计件毛体总和
    refreshTotals() {
      let quantity = 0
      let weight = 0
      let cubage = 0
      if (this.job && this.job.lclSlaves) {
        if (this.job.lclSlaves.length > 0) {
          for (const j of this.job.lclSlaves) {
            quantity += j.quantityContract
            weight += j.weightContract
            cubage += j.cubageContract
          }
          this.job.quantityContract = Number(quantity.toFixed(0))
          this.job.cubageContract = Number(cubage.toFixed(3))
          if (this.job.weightContract === 0) {
            this.job.weightContract = Number(weight.toFixed(2))
          }
        }
      }
      this.lbTotal.lblTotalWeight = weight.toFixed(3)
      this.lbTotal.lblTotalCubage = cubage.toFixed(3)
      this.lbTotal.lblTotalQuantity = quantity.toFixed(0)
    },
    checkValueMatch() {
      let airport = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', this.job.loadingPortCode)
      this.valueMatch.loadingPortCode = airport && airport.englishName
      airport = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', this.job.dischargingPortCode)
      this.valueMatch.dischargingPortCode = airport && airport.englishName
    },
    // 组装打印参数
    getPrintData() {
      return { JOB_UUID: this.job.uuid, category: 'AIJOBNO', ctx: new AirImportJob(this.job) }
    },
    onMblCodeInput(value) {
      this.mblCode = value
      if (value.length === 3) {
        this.$refs.mblNum.$refs.cargoInput.focus()
      }
    },
    onMblCodeNumBlur() {
      const codeNum = this.mblCode + this.mblNum
      if (codeNum) {
        if (AirExportUtils.validateMAWBNum(codeNum)) {
          this.mblCodeNumValidate = true
        } else {
          this.mblCodeNumValidate = false
        }
        if (!this.job.express) {
          const company = JobUtils.getAirLineCompanyByMblPrefixAndOfficeId(this.mblCode, this.$store.getters.currentOfficeId)
          if (company) {
            this.job.carrierId = company.cmpIdx
          }
        }
        // this.fillMBL()
      } else {
        this.mblCodeNumValidate = true
      }
    },
    // fillMBL() {
    //   const job = this.job
    //   if (!job.express) {
    //     if (this.mblCode.length === 3 && !this.mblNum) {
    //       job.mbl = this.mblCode.replace(/-/g, '')
    //     } else {
    //       job.mbl = this.mblCode.replace(/-/g, '')
    //       if (this.mblNum) {
    //         job.mbl += '-'
    //         job.mbl += this.mblNum
    //       }
    //     }
    //   }
    // },
    filterNonDigit(value) {
      return value.replace(/[^\d-]/g, '')
    },
    cargoSource_Change(obj) {
      this.setJobSelectValue(obj)
      this.job.designationAgent = 0
      OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
      JobUtils.matchUserPortConfig(this, this.job)
    },
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
    },
    async loadingPortCodeChange(data) {
      this.syncRegion(data)
      this.setJobSelectValue(data)
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    async syncJobPortCargoDoc(cargoDoc) {
      const job = this.job
      cargoDoc.podTo = job.dischargingPortCode
      const airportDes = await AirPort.getAirportByCode(job.dischargingPortCode)
      cargoDoc.airportOfDestination = !airportDes ? '' : airportDes.englishName
      if (job.airCargoDoc) {
        const index = job.airCargoDoc.findIndex(doc => doc.docType === cargoDoc.docType)
        if (index >= 0) {
          job.airCargoDoc[index] = cargoDoc
        } else {
          job.airCargoDoc.push(cargoDoc)
        }
      } else {
        job.airCargoDoc = [cargoDoc]
      }
    },
    // CARGO-40263 【航线】取值逻辑：取【装货港】 对应的 【空港】的【区域】字段值 如【装货港】未对应有区域值时，显示为空。
    async syncRegion(data) {
      // 只需要考虑修改的值为空或者不等当前值的情况即可，因为如果一致不会走到这里
      this.job.regionName = ''
      if (data && data.value !== this.job.loadingPortCode) {
        const port = await AirPort.getAirportByCode(data.value)
        if (port && port.region) {
          this.job.regionName = this.isZh() ? port.regionCnName : port.regionEnName
        }
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    setJobSelectNum(obj) {
      this.job[obj.key] = obj.value || 0
    },
    async designationAgentChangeHandler(company) {
      if (!company.cmpIdx) {
        this.job.designationAgent = 0
        this.job.sales = 0
        OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
        return
      }
      this.job.designationAgent = company.cmpIdx
      const overseaAgentDetail = await new Company({ uuid: company.uuid }).getOverseaAgentDetail()
      if (overseaAgentDetail) {
        this.job.sales = 0
        if (this.salesOfficeCheck) {
          for (const option of this.$refs.sales.options) {
            if (option.userId === overseaAgentDetail.owner && option.active) {
              this.job.sales = overseaAgentDetail.owner
              break
            }
          }
        } else {
          this.job.sales = overseaAgentDetail.owner
        }
        // 添加指定货代理等级
        const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
        if (overseaAgentGrade) {
          this.job.agentLevel = overseaAgentGrade.chineseName
        }
      }
      OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
    },
    async txtCarrierId_changeHandler(company) {
      if (!company.cmpIdx) {
        this.job.carrierId = 0
        this.mblCode = ''
        return
      }
      this.job.carrierId = company.cmpIdx
      const airlineDetail = await new Company({ uuid: company.uuid }).getAirlineDetail()
      if (airlineDetail && !this.job.express) {
        this.mblCode = airlineDetail.mawbprefix
      }
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    async dischargingPortCode_Change(data) {
      this.valueMatch.dischargingPortCode = true
      this.job.dischargingPortCode = data.value
      this.job.destinationPortCode = data.value
      if (data.value) {
        this.job.destinationPlace = data.englishName
      }
      const mawb = await new AirImportJob(this.job).getCargoDoc(CargoDocConsts.MAWB, true)
      if (mawb) {
        this.syncJobPortCargoDoc(mawb)
      }
      const hawb = await new AirImportJob(this.job).getCargoDoc(CargoDocConsts.HAWB, true)
      if (hawb) {
        this.syncJobPortCargoDoc(hawb)
      }
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    txtCargoInformationChangeHandler(obj) {
      this.setJobSelectValue(obj)
      this.job.cargoName = obj.englishName || ''
    },
    async etdChange(value) {
      this.job.etd = value
      this.job.sailingDay = JobUtils.dateChange(this.job.etd)
    },
    async etaChange(value) {
      this.job.eta = value
      this.job.etaSailingDay = JobUtils.dateChange(this.job.eta)
      this.job.businessDate = this.job.eta
      const modifiedData = this.context.modifiedData
      modifiedData.charges = modifiedData.charge || []
      const charges = await new AirImportJob(this.job).getCharges()
      for (const charge of charges) {
        charge.businessDate = this.job.businessDate
        modifiedData.charges.push(charge)
      }
      await ChargeUtils.updateETDFee(this.job, this.job.eta, this.context, true)
    },
    async atdChange(value) {
      this.job.atd = value
      this.job.atdSailingDay = JobUtils.dateChange(this.job.atd)
    },
    async ataChange(value) {
      this.job.ata = value
      this.job.ataSailingDay = JobUtils.dateChange(this.job.ata)
    },
    async quantityContractChange() {
      this.job.quantityContract = this.job.quantityActual
    },
    async weightContractChange() {
      this.job.weightContract = this.job.weightActual
      await this.refreshWeightCharge(this.job, this.job.weightContract)
      this.calculateChargeWeight()
    },
    async refreshWeightCharge(job, weight) {
      const charges = ChargeUtils.weightChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = weight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
      ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.context)
    },
    async cubageContractChange() {
      this.job.cubageContract = this.job.cubageActual
      await this.refreshCubageCharge(this.job, this.job.cubageContract)
      this.calculateChargeWeight()
    },
    async refreshCubageCharge(job, cubage) {
      const charges = await ChargeUtils.cubageChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = cubage
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
    },
    /**
     * 单号抄录
     */
    async onExcerptionChangeFunc(data) {
      this.job.shipperCode = data.shipperCode
      this.job.shipperLine1 = data.shipperLine1
      this.job.consigneeCode = data.consigneeCode
      this.job.consigneeLine1 = data.consigneeLine1
      this.job.notifyCode = data.notifyCode
      this.job.notifyLine1 = data.notifyLine1
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
        if (data.hasOwnProperty('shipperCode')) {
          this.job['shipperCode'] = data.shipperCode || ''
        }
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
        if (data.hasOwnProperty('consigneeCode')) {
          this.job['consigneeCode'] = data.consigneeCode || ''
        }
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
        if (data.hasOwnProperty('notifyCode')) {
          this.job['notifyCode'] = data.notifyCode || ''
        }
      }
    },
    mergeShipperLine() {
      let result = ''
      if (this.job['shipperLine1']) {
        for (let i = 1; i < 7; ++i) {
          result += this.job['shipperLine' + i] || ''
          result += '\n'
        }
        result += (this.job['shipperLine7'] || '')
      }
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      if (this.job['consigneeLine1']) {
        for (let i = 1; i < 7; ++i) {
          result += this.job['consigneeLine' + i] || ''
          result += '\n'
        }
        result += (this.job['consigneeLine7'] || '')
      }
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      if (this.job['notifyLine1']) {
        for (let i = 1; i < 7; ++i) {
          result += this.job['notifyLine' + i] || ''
          result += '\n'
        }
        result += (this.job['notifyLine7'] || '')
      }
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['notifyLine' + i] = ''
      }
    },
    async shipperAutoCompleteChange(company) {
      const job = this.job
      if (!company.cmpIdx) {
        job.shipperId = 0
        return
      }
      job.shipperId = company.cmpIdx
      const manifestAddress = await new Company({ uuid: company.uuid }).getManifestAddress()
      if (manifestAddress) {
        job.shipperLine1 = manifestAddress.addressLine1
        job.shipperLine2 = manifestAddress.addressLine2
        job.shipperLine3 = manifestAddress.addressLine3
        job.shipperLine4 = manifestAddress.addressLine4
        job.shipperLine5 = manifestAddress.addressLine5
        job.shipperLine6 = manifestAddress.addressLine6
        job.shipperLine7 = manifestAddress.addressLine7
      } else {
        job.shipperLine1 = ''
        job.shipperLine2 = ''
        job.shipperLine3 = ''
        job.shipperLine4 = ''
        job.shipperLine5 = ''
        job.shipperLine6 = ''
        job.shipperLine7 = ''
      }
    },
    async consigneeAutoCompleteChange(company) {
      const job = this.job
      if (!company.cmpIdx) {
        job.consigneeId = 0
        return
      }
      job.consigneeId = company.cmpIdx
      const manifestAddress = await new Company({ uuid: company.uuid }).getManifestAddress()
      if (manifestAddress) {
        job.consigneeLine1 = manifestAddress.addressLine1
        job.consigneeLine2 = manifestAddress.addressLine2
        job.consigneeLine3 = manifestAddress.addressLine3
        job.consigneeLine4 = manifestAddress.addressLine4
        job.consigneeLine5 = manifestAddress.addressLine5
        job.consigneeLine6 = manifestAddress.addressLine6
        job.consigneeLine7 = manifestAddress.addressLine7
      } else {
        job.consigneeLine1 = ''
        job.consigneeLine2 = ''
        job.consigneeLine3 = ''
        job.consigneeLine4 = ''
        job.consigneeLine5 = ''
        job.consigneeLine6 = ''
        job.consigneeLine7 = ''
      }
      JobUtils.matchUserPortConfig(this, this.job)
    },
    async notifyAutoCompleteChange(company) {
      const job = this.job
      if (!company.cmpIdx) {
        job.notifyId = 0
        return
      }
      job.notifyId = company.cmpIdx
      const manifestAddress = await new Company({ uuid: company.uuid }).getManifestAddress()
      if (manifestAddress) {
        job.notifyLine1 = manifestAddress.addressLine1
        job.notifyLine2 = manifestAddress.addressLine2
        job.notifyLine3 = manifestAddress.addressLine3
        job.notifyLine4 = manifestAddress.addressLine4
        job.notifyLine5 = manifestAddress.addressLine5
        job.notifyLine6 = manifestAddress.addressLine6
        job.notifyLine7 = manifestAddress.addressLine7
      } else {
        job.notifyLine1 = ''
        job.notifyLine2 = ''
        job.notifyLine3 = ''
        job.notifyLine4 = ''
        job.notifyLine5 = ''
        job.notifyLine6 = ''
        job.notifyLine7 = ''
      }
    },
    showAdvanceTextDialog(title, value, textChars, successCallback, isUppercase = true) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.textChars = textChars
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    /**
     * 计算计费重量
     * 空运体积和重量的换算是体积（立方米）/0.006=体积重量（公斤）
     * 体积重量大于实际重量时候，计费重量就是体积重量
     * 体积重量小于实际重量的时候，计费重量就是实际重量
     * 0.1《尾数《0.5，则应为进位到0.5
     * 0.5《尾数《1则应进位到1
     */
    calculateChargeWeight() {
      const job = this.job
      const chargeWeight = job.cubageContract / 0.006
      let value = ''
      if (chargeWeight > job.weightContract) {
        value = ImportConstants.toFixed2(chargeWeight, 1)
      } else {
        value = ImportConstants.toFixed2(job.weightContract, 1)
      }
      job.chargeWeight = Number(value)
    },
    /**
     * 当选择销售人员的时候自动关联该销售所在分公司
     */
    async salesChangeHandler(data) {
      const job = this.job
      job.sales = data.value || 0
      job.salesOffice = 0
      this.txtSalesOffice = ''
      job.salesDepartment = 0
      if (data.value) {
        if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
          job.salesOffice = data.defaultOfficeId
          job.salesDepartment = data.defaultDepId
          const office = await Office.getOfficeById(job.salesOffice)
          this.txtSalesOffice = office.chineseName
        } else {
          const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
          if (offices.length > 1) {
            for (const item of offices) {
              if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
                job.salesOffice = item.officeId
                job.salesDepartment = item.departmentId
                this.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', job.salesOffice, 'chineseName')
                break
              }
            }
          } else {
            const user = new User(data)
            const department = await user.getDefaultDepartment('role', 'sales')
            job.salesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            if (office) {
              job.salesOffice = office.officeId
              this.txtSalesOffice = office.chineseName
            }
          }
        }
      }
    },
    departmentChangeHandler(department) {
      if (!department.departmentId) {
        this.job.salesDepartment = 0
        return
      }
      this.job.salesDepartment = department.departmentId
      const office = this.context.officeList.find(p => p.uuid === department.officeUuid)
      if (office && office.officeId !== this.job.salesOffice) {
        this.job.salesOffice = office.officeId
        this.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', office.officeId, 'chineseName')
      }
    },
    /**
     * 客服改变
     */
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    },
    /**
     * 操作改变
     */
    opChangeHandler(user) {
      const job = this.job
      job.op = user.userId || 0
      if (user.defaultDepId > 0) {
        job.opDepartment = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.dcOffice = office ? office.officeId : 0
              job.dcDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'doc')
          job.dcDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.dcOffice = office ? office.officeId : 0
        }
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    },
    async addTicket_clickHandler() {
      if (!this.job.mbl) {
        this.$message.warning(this.$t('AirImport.MasterPleaseMaintainTheFirst'))
        return
      }
      this.context.loading = true
      try {
        await batchCloneLcLJob({
          jobUuid: this.job.uuid,
          branchId: this.context.office.officeId
        }).then(res => {
          const lclJob = res.data
          lclJob.lclMasterUuid = this.job.uuid
          lclJob.lclMaster = this.job
          lclJob.master = this.job
          lclJob.carrierId = this.job.carrierId
          lclJob.voyageFlight = this.job.voyageFlight
          lclJob.cargoSalesId = this.job.cargoSalesId
          lclJob.loadingPortCode = this.job.loadingPortCode
          lclJob.dischargingPortCode = this.job.dischargingPortCode
          lclJob.destinationPlace = this.job.destinationPlace
          lclJob.tradeTerm = '110'
          this.$emit('addLcl', lclJob)
        })
      } finally {
        this.context.loading = false
      }
    },
    editTicket_clickHandler() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.lclSlaves[cell.rowIndex] : null
      if (row) {
        this.$emit('selectJob', row.uuid)
      } else {
        this.$message.info(this.$t('AirImport.PleaseTicketToBeEdited'))
      }
    },
    async slavedAddedHandler(rows) {
      this.context.loading = true
      try {
        const res = await batchAddJob(rows, this.job.uuid, this.job.mbl, this.location)
        if (res.data.length > 0) {
          this.$emit('addSlavedJob', res.data)
          this.job.lclSlaves.push(...res.data)
          await new AirImportJob(this.job).loadJobRelated({ job: true })
          await JobUtils.checkMasterShare(this.job.uuid)
        }
      } finally {
        this.context.loading = false
      }
    },
    async removeTicket_clickHandler() {
      const selectedItems = this.gridApi.getSelectedRows()
      if (selectedItems.length === 0) {
        this.$message.info(this.$t('SeaExport.UncheckedSmallTicket'))
        return
      }
      const isOk = await this.$confirm(this.$t('queryJob.AreWantToRemoveTicket'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('constant.yes'),
        cancelButtonText: this.$t('constant.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => true).catch(() => false)
      if (!isOk) {
        return
      }
      this.context.loading = true
      try {
        const jobKeys = Array.from(selectedItems, p => p.uuid)
        await checkJobForShared(jobKeys).then(res => {
          if (res.data) {
            this.$message.warning(res.data + this.$t('CargoMsg.Cargo_SmallTicketCannotBeRemoved'))
          } else {
            this.doRemoveHandler(jobKeys)
          }
        })
      } finally {
        this.context.loading = false
      }
    },
    async doRemoveHandler(jobKeys) {
      const res = await batchRemoveJob(jobKeys, this.location)
      await this.onBatchRemoveSucceeded(res.data, jobKeys)
    },
    async onBatchRemoveSucceeded(num, removedJobKeys) {
      if (num > 0) {
        this.$emit('removeJobFromMaster', removedJobKeys)
        this.job.lclSlaves = ''
        await new AirImportJob(this.job).loadJobRelated({ job: true, lclSlaves: true })
      }
    },
    endTabHandler() {
      this.fillModel()
    },
    fillModel() {
      const job = this.job
      if (!job.express) {
        this.job.mbl = this.mblCode
        if (this.mblNum) {
          this.job.mbl += this.mblNum
        }
      }
    },
    async getSubmitData() {
      await this.validateForm()
      const job = this.job
      const modifiedData = this.context.modifiedData
      modifiedData.lclSlaves = modifiedData.lclSlaves || []
      for (const item of job.lclSlaves) {
        if (item.mbl !== job.mbl || item.etd !== job.etd || item.eta !== job.eta) {
          item.mbl = job.mbl
          item.etd = job.etd
          item.eta = job.eta
          item.businessDate = item.eta
          modifiedData.lclSlaves.push(item)
        }
      }
      if (this.job.airCargoDoc && this.job.airCargoDoc.length > 0) {
        return { job, airCargoDoc: this.job.airCargoDoc }
      }
      return { job }
    },
    async validateForm() {
      const form = this.job
      await JobUtils.checkCustomerBranchScope(form, 'tabBookingMaster')
      if (form.cargoSource === 'NC') {
        if (form.designationAgent < 1) {
          throw new TabError(this.$t('queryJob.SpecifiedFreightAgentCannotEmpty'), 'tabBookingMaster')
        }
      }
      if (!form.loadingPortCode || !this.valueMatch.loadingPortCode) {
        throw new TabError(this.$t('Message.PortOfLoadingPortCannotBeNull'), 'tabBookingMaster')
      }
      if (!form.dischargingPortCode || !this.valueMatch.dischargingPortCode) {
        throw new TabError(this.$t('Message.PortOfDestinationCannotBeNull'), 'tabBookingMaster')
      }
      if (!form.destinationPlace) {
        throw new TabError(this.$t('Message.PlaceOfDeliveryCannotBeNull'), 'tabBookingMaster')
      }
      // 动态读取UI配置，如果UI配置中ETD为必填，则进行校验
      if (this.elementDict && this.elementDict.etd && this.elementDict.etd.isRequire && !form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeNull'), 'tabBookingMaster')
      }
      if (!form.eta) {
        throw new TabError(this.$t('queryJob.ArrivalDateCannotBlank'), 'tabBookingMaster')
      }
      if (form.etd && form.eta && form.eta < form.etd) {
        throw new TabError(this.$t('Message.DateOfDepartureCannotBeLaterThanDateOfArrival'), 'tabBookingMaster')
      }
      // if (form.cargoSource === CargoSource.SC_CARGO_SOURCE.code && form.sales === 0) {
      //   throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabBookingMaster')
      // }
      if (form.opDepartment === 0) {
        throw new TabError(this.$t('queryJob.OperationDepartmentCannotBlank'), 'tabBookingMaster')
      }
      // if (form.sales > 0 && form.salesDepartment <= 0) {
      //   throw new TabError(this.$t('Message.SalesDepartmentIsNullPleaseReSelectSales'), 'tabBookingMaster')
      // }
      if (form.loadingAgentId > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.PortOfLoadingAgent'), form.loadingAgentId)
      }
      if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && form.designationAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.NominatedAgent'), form.designationAgent)
      }
      if (form.carrierId > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.AirlineCompany'), form.carrierId)
      }
      if (form.bookingAgent > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.BillExchangeAgent'), form.bookingAgent)
      }
      if (form.groundAgentId > 0) {
        await SecurityUtil.companyisActive(this.$t('SeaExport.AirportHandlingAgent'), form.groundAgentId)
      }
      // 中邮定制字段 保存校验
      if (this.isZY && !form.saleProductCode) {
        throw new TabError(this.$t('Message.SaleProductCodeCannotBeNull'), 'tabBookingMaster')
      }
      if (this.isZY && !form.fullOrInside) {
        throw new TabError(this.$t('Message.FullOrInsideCannotBeNull'), 'tabBookingMaster')
      }
    },
    // 投保
    toInsure() {
      if (cache.config.get('BurialPointMode') === 'on') {
        // LogStores.sendFunctionClickLogStoresByLabel('AI-主票信息' + this.view.$t('SeaExport.Insure'))
      }
      if (this.$checkPermission(['button_insurance_toInsure'])) {
        const job = deepCopy(this.job)
        cleanCircleObject(job)
        AirImportJob.toInsure(job, this.context.office).then(data => {
          this.insureSuccessHandler(data)
        })
      } else {
        this.$message.warning(this.$t('SeaExport.NotInsuranceOperationPermission'))
      }
    },
    // 投保成功
    insureSuccessHandler(data) {
      const result = data.result
      const status = data.status
      if (status === 'true') {
        window.open(result, '_blank', 'noreferrer')
      } else {
        this.$message.warning(result)
      }
    },
    // 自定义岗位字段1
    async userDefinedRoleId1Handler(data) {
      const job = this.job
      job.userDefinedRoleId1 = data.value || 0
      job.userDefinedRoleDept1 = 0
      job.userDefinedRoleOffice1 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept1 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice1 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
          job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice1 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段2
    async userDefinedRoleId2Handler(data) {
      const job = this.job
      job.userDefinedRoleId2 = data.value || 0
      job.userDefinedRoleDept2 = 0
      job.userDefinedRoleOffice2 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept2 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice2 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
          job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice2 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段3
    async userDefinedRoleId3Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId3 = value || 0
      job.userDefinedRoleDept3 = 0
      job.userDefinedRoleOffice3 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept3 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice3 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
          job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice3 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段4
    async userDefinedRoleId4Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId4 = value || 0
      job.userDefinedRoleDept4 = 0
      job.userDefinedRoleOffice4 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept4 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice4 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
          job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice4 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段5
    async userDefinedRoleId5Handler(data) {
      const job = this.job
      job.userDefinedRoleId5 = data.value || 0
      job.userDefinedRoleDept5 = 0
      job.userDefinedRoleOffice5 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept5 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice5 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
          job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice5 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段6
    async userDefinedRoleId6Handler(data) {
      const job = this.job
      job.userDefinedRoleId6 = data.value || 0
      job.userDefinedRoleDept6 = 0
      job.userDefinedRoleOffice6 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept6 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice6 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
          job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice6 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段7
    async userDefinedRoleId7Handler(data) {
      const job = this.job
      job.userDefinedRoleId7 = data.value || 0
      job.userDefinedRoleDept7 = 0
      job.userDefinedRoleOffice7 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept7 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice7 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
          job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice7 = office ? office.officeId : 0
        }
      }
    },
    /**
     * 航线改变
     */
    async plannerChangeHandler(data) {
      const job = this.job
      job.planner = data.value || 0
      job.plannerDepartment = 0
      job.plannerOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'airline', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.plannerOffice = office ? office.officeId : 0
              job.plannerDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'airline')
          job.plannerDepartment = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.plannerOffice = office ? office.officeId : 0
        }
      } else {
        job.planner = 0
        job.plannerDepartment = 0
        job.plannerOffice = 0
      }
    },
    async cargoSalesChargeHandler(data) {
      const job = this.job
      job.cargoSalesId = data.value || 0
      job.cargoSalesDepartment = 0
      job.cargoSalesOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.cargoSalesOffice = office ? office.officeId : 0
              job.cargoSalesDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'salesOfGoods')
          if (department) {
            job.cargoSalesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            job.cargoSalesOffice = office ? office.officeId : 0
          }
        }
      }
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.job })
    },
    onCustomJobTypeChange(obj) {
      this.setJobSelectValue(obj)
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
      this.job.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.job.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.job.customJobType, this.job.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.job.opOffice = val
    },
    onCargoTypeChagne(data) {
      this.setJobSelectValue(data)
      JobUtils.matchUserPortConfig(this, this.job)
    },
    changeProject(p) {
      this.job.poNo = p.value
      this.job.projectName = p.projectName
    }
  }
}
